import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ENVIRONMENT} from 'src/environments/environment.token';
import {InsurerApiAvailability} from './insurer-api-availability';

@Injectable({
  providedIn: 'root',
})
export class InsurerApiAvailabilityService {
  private readonly http = inject(HttpClient);
  private readonly environment = inject(ENVIRONMENT);

  getInsurerApiAvailability(): Observable<InsurerApiAvailability[]> {
    return this.http.get<InsurerApiAvailability[]>(
      `${this.environment.appConfig.apiBaseUrl}/v1/insurer-api-availability`
    );
  }
}
